var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pdf-viewport-tools" },
    [
      _c(
        "b-button",
        {
          attrs: {
            size: "sm",
            variant: "primary",
            type: "submit",
            disabled: _vm.value === 1
          },
          on: {
            click: function($event) {
              return _vm.$emit("input", 1)
            }
          }
        },
        [
          _c("feather-icon", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover.left",
                value: "Primera página",
                expression: "'Primera página'",
                modifiers: { hover: true, left: true }
              }
            ],
            attrs: { icon: "ChevronsLeftIcon" }
          })
        ],
        1
      ),
      _c(
        "b-button",
        {
          attrs: {
            size: "sm",
            variant: "primary",
            type: "submit",
            disabled: _vm.value === 1
          },
          on: {
            click: function($event) {
              return _vm.$emit(
                "input",
                _vm.value != -1 ? _vm.value - 1 : _vm.pages - 1
              )
            }
          }
        },
        [
          _c("feather-icon", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover.left",
                value: "Página anterior",
                expression: "'Página anterior'",
                modifiers: { hover: true, left: true }
              }
            ],
            attrs: { icon: "ChevronLeftIcon" }
          })
        ],
        1
      ),
      _c("PdfPageSelector", {
        attrs: { value: _vm.value, pages: _vm.pages, small: "" },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event)
          }
        }
      }),
      _c(
        "b-button",
        {
          attrs: {
            size: "sm",
            variant: "primary",
            type: "submit",
            disabled: _vm.value === _vm.pages || _vm.value === -1
          },
          on: {
            click: function($event) {
              return _vm.$emit("input", _vm.value + 1)
            }
          }
        },
        [
          _c("feather-icon", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover.left",
                value: "Página siguiente",
                expression: "'Página siguiente'",
                modifiers: { hover: true, left: true }
              }
            ],
            attrs: { icon: "ChevronRightIcon" }
          })
        ],
        1
      ),
      _c(
        "b-button",
        {
          attrs: {
            size: "sm",
            variant: "primary",
            type: "submit",
            disabled: _vm.value === _vm.pages || _vm.value === -1
          },
          on: {
            click: function($event) {
              return _vm.$emit("input", _vm.pages)
            }
          }
        },
        [
          _c("feather-icon", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover.left",
                value: "Última página",
                expression: "'Última página'",
                modifiers: { hover: true, left: true }
              }
            ],
            attrs: { icon: "ChevronsRightIcon" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }